import React from "react"
import FileDownload from "../FileDownload/FileDownload"
import * as Style from "./VideoInformation.module.scss"

const VideoInformation = ({ video }) => {
  return (
    <div className={Style.wrapper}>
      <div className={Style.title}>Description:</div>
      <p className={Style.text}>{video.description}</p>
      <div className={Style.title}>Video topics:</div>
      <p className={Style.text}>{video.description}</p>
      {video.additional_resources && (
        <>
          <div className={Style.title}>
            Additional resources<span>(optional)</span>:
          </div>
          <div className={Style.file_wrapper}>
            {video.additional_resources.map((resource, index) => {
              return <FileDownload key={index} file={resource} />
            })}
          </div>
        </>
      )}
    </div>
  )
}

export default VideoInformation
